import { EventListener, type HttpClient } from "silver";

export class RequestCache {
	public readonly onIdle = EventListener.create("idle");
	public readonly onBusy = EventListener.create("busy");
	private requestCount: number = 0;
	private requestCache: { [url: string]: Promise<any> } = { };

	constructor(private readonly httpClient: HttpClient) { }

	public precache(url: string, result: any): void {
		if (url.slice(0, 4) !== "http") {
			url = document.location.protocol + "//" + document.location.hostname + url;
		}
		this.requestCache[url] = Promise.resolve(result);
	}

	public request<T>(url: string): Promise<T> {
		if (! this.requestCache.hasOwnProperty(url)) {
			this.changeRequestCount(1);
			this.requestCache[url] = this.httpClient.get(url)
				.then((response: T) => {
					this.changeRequestCount(-1);
					return response;
				})
				.catch((err: any) => {
					console.error("Request failed", err);
					this.changeRequestCount(-1);
				});
		}
		return this.requestCache[url];
	}

	private changeRequestCount(val: number): void {
		if (this.requestCount === 0 && val > 0) {
			this.requestCount += val;
			this.onBusy.trigger({ });
		} else if (this.requestCount > 0 && val < 0) {
			this.requestCount += val;
			this.onIdle.trigger({ });
		}
	}
}
